import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './pages/Auth/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = null }) => {
  const { currentUser, isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!allowedRoles) {
    return children;
  }

  const roles = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];

  if (currentUser?.role === 'ROLE_ADMIN') {
    return children;
  }

  if (currentUser?.role && roles.includes(currentUser.role)) {
    return children;
  }

  return <Navigate to="/forbidden" />;
};

export default ProtectedRoute;